import styled from 'styled-components';
import { colors, spacing, textColors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { GhostButton, GhostSuccessButton, IconButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { Add16 } from 'ui/icons';

export const LinkContent = styled.span<{ isUnderlined?: boolean }>`
  ${(props) => (props.isUnderlined ? `text-decoration: underline;` : '')}
  color: ${textColors.textLink};
  max-width: ${pxToRem(200)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ReadOnlyLink = styled.a`
  display: inline-flex;
  align-items: center;
  position: relative;
  gap: ${spacing.eighth};
  margin-left: ${spacing.quarter};
  padding-bottom: ${spacing.half};
  text-decoration: none;
`;

export const ButtonTitle = styled.span<{ $hasError: boolean }>`
  color: ${({ theme, $hasError }) =>
    $hasError ? theme.colors.utilityColors.negative100 : theme.colors.textColors.textPrimary};
  padding-right: 15px;
`;

export const ButtonTypeVariationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${spacing.plusQuarter};
  gap: ${spacing.plusQuarter};
  width: ${({ theme }) => theme.spacing.utils.pxToRem(356)};
  background: ${({ theme }) => theme.colors.backgroundColors.backgroundSecondary};
  margin-bottom: 15px;
  border-radius: ${spacing.fiveEights};
`;

export const ButtonTypeVariationHeaderContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: space-between;

  ${({ isExpanded, theme }) =>
    isExpanded
      ? `padding-bottom: ${spacing.plusQuarter};
     border-bottom: ${theme.spacing.values.single} solid ${theme.colors.neutrals.grey15};
    `
      : ''}
`;

export const ButtonController = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteIconWrapper = styled(IconButton)`
  :focus::before {
    border: none;
  }
`;

export const InputWrapper = styled.div<{ gap?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ gap }) => gap && spacing.plusQuarter};
`;

export const StyledFilterInput = styled(InputText)`
  margin-top: ${spacing.threeQuarter};
`;

export const InputPrefix = styled.span`
  color: ${colors.grey60};
`;

export const AddParamButton = styled(GhostSuccessButton)`
  margin-top: ${spacing.half};
`;

export const DeleteButton = styled(GhostButton)`
  gap: ${pxToRem(9)};
`;

export const StyledAddIcon = styled(Add16)`
  margin-right: ${spacing.threeQuarter};
`;

export const LinkParameterInputWrapper = styled.div`
  background: ${colors.grey1};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  margin: ${spacing.threeQuarter} 0;
  padding: ${spacing.base};
  border-radius: ${spacing.half};
  [data-test='input-wrapper'] {
    margin-right: ${spacing.half};
  }
`;

export const StyledInputText = styled(InputText)`
  width: 100%;
`;

export const KeyValuePairText = styled.div`
  margin-top: ${spacing.half};
  word-break: break-word;
`;
